import { useNavigate, useRouter } from '@tanstack/react-router'
import { useAuth } from '../hooks/useAuth'
import type { ReactNode } from 'react'

interface AuthGuardProps {
  children: ReactNode
}

const publicPaths = ['/login']
/**
 * 认证守卫组件
 * 用于保护需要认证的页面和组件
 */
export default function AuthGuard({ children }: AuthGuardProps) {
  const { isAuthenticated } = useAuth()

  const router = useRouter()
  const navigate = useNavigate()
  if (!isAuthenticated) {
    navigate({ to: '/login' })
  } else if (publicPaths.includes(router.latestLocation.pathname)) {
    // 如果用户已认证但访问的是公共路径，则重定向到首页
    navigate({ to: '/' })
  }

  return <>{children}</>
}
